<template><section><h1>Select 选择器</h1>
<p>当选项过多时，使用下拉菜单展示并选择内容。</p>

<h3>基础用法</h3>
<demo-block>
                <div class="source" slot="source"><ayu-select v-model="inputValue" placeholder="请选择">
  <ayu-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
    {{ item.label }}
  </ayu-option>
</ayu-select>


</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"inputValue"</span> <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"请选择"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ayu-option</span> 
    <span class="hljs-attr">v-for</span>=<span class="hljs-string">"item in options"</span> 
    <span class="hljs-attr">:key</span>=<span class="hljs-string">"item.value"</span> 
    <span class="hljs-attr">:label</span>=<span class="hljs-string">"item.label"</span> 
    <span class="hljs-attr">:value</span>=<span class="hljs-string">"item.value"</span>&gt;</span>
    {{ item.label }}
  <span class="hljs-tag">&lt;/<span class="hljs-name">ayu-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data() {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">inputValue</span>: <span class="hljs-string">''</span>,
        <span class="hljs-attr">options</span>: [
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'苹果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'apple'</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'香蕉'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Banana'</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'火龙果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Pitaya'</span>,
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'草莓'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Strawberry'</span>
          }
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">scoped</span>&gt;</span><span class="css">
  <span class="hljs-selector-class">.select-wrapper</span> {
    <span class="hljs-attribute">width</span>: <span class="hljs-number">200px</span>;
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>禁用选项</h3>
<demo-block>
                <div class="source" slot="source"><ayu-select v-model="inputValue2" placeholder="请选择">
  <ayu-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
    {{ item.label }}
  </ayu-option>
</ayu-select>


</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"inputValue2"</span> <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"请选择"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ayu-option</span> 
    <span class="hljs-attr">v-for</span>=<span class="hljs-string">"item in options2"</span> 
    <span class="hljs-attr">:key</span>=<span class="hljs-string">"item.value"</span> 
    <span class="hljs-attr">:label</span>=<span class="hljs-string">"item.label"</span> 
    <span class="hljs-attr">:value</span>=<span class="hljs-string">"item.value"</span>
    <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"item.disabled"</span>&gt;</span>
    {{ item.label }}
  <span class="hljs-tag">&lt;/<span class="hljs-name">ayu-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data() {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">inputValue2</span>: <span class="hljs-string">''</span>,
        <span class="hljs-attr">options2</span>: [
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'苹果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'apple'</span>,
            <span class="hljs-attr">disabled</span>: <span class="hljs-literal">true</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'香蕉'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Banana'</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'火龙果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Pitaya'</span>,
            <span class="hljs-attr">disabled</span>: <span class="hljs-literal">true</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'草莓'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Strawberry'</span>
          }
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">scoped</span>&gt;</span><span class="css">
  <span class="hljs-selector-class">.select-wrapper</span> {
    <span class="hljs-attribute">width</span>: <span class="hljs-number">200px</span>;
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>基础多选</h3>
<demo-block>
                <div class="source" slot="source"><ayu-select v-model="inputValue3" placeholder="请选择" multiple>
  <ayu-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
    {{ item.label }}
  </ayu-option>
</ayu-select>


</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"inputValue3"</span> <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"请选择"</span> <span class="hljs-attr">multiple</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ayu-option</span> 
    <span class="hljs-attr">v-for</span>=<span class="hljs-string">"item in options3"</span> 
    <span class="hljs-attr">:key</span>=<span class="hljs-string">"item.value"</span> 
    <span class="hljs-attr">:label</span>=<span class="hljs-string">"item.label"</span> 
    <span class="hljs-attr">:value</span>=<span class="hljs-string">"item.value"</span>&gt;</span>
    {{ item.label }}
  <span class="hljs-tag">&lt;/<span class="hljs-name">ayu-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data() {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">inputValue3</span>: [<span class="hljs-string">'apple'</span>, <span class="hljs-string">'Banana'</span>],
        <span class="hljs-attr">options3</span>: [
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'苹果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'apple'</span>,
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'香蕉'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Banana'</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'火龙果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Pitaya'</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'草莓'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Strawberry'</span>
          }
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">scoped</span>&gt;</span><span class="css">
  <span class="hljs-selector-class">.select-wrapper</span> {
    <span class="hljs-attribute">width</span>: <span class="hljs-number">200px</span>;
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>缩略显示</h3>
<demo-block>
                <div class="source" slot="source"><ayu-select v-model="inputValue4" placeholder="请选择" multiple collapse-tags="">
  <ayu-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
    {{ item.label }}
  </ayu-option>
</ayu-select>


</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"inputValue4"</span> <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"请选择"</span> <span class="hljs-attr">multiple</span> <span class="hljs-attr">collapse-tags</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ayu-option</span> 
    <span class="hljs-attr">v-for</span>=<span class="hljs-string">"item in options4"</span> 
    <span class="hljs-attr">:key</span>=<span class="hljs-string">"item.value"</span> 
    <span class="hljs-attr">:label</span>=<span class="hljs-string">"item.label"</span> 
    <span class="hljs-attr">:value</span>=<span class="hljs-string">"item.value"</span>&gt;</span>
    {{ item.label }}
  <span class="hljs-tag">&lt;/<span class="hljs-name">ayu-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data() {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">inputValue4</span>: [<span class="hljs-string">'apple'</span>, <span class="hljs-string">'Banana'</span>],
        <span class="hljs-attr">options4</span>: [
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'苹果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'apple'</span>,
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'香蕉'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Banana'</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'火龙果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Pitaya'</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'草莓'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Strawberry'</span>
          }
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">scoped</span>&gt;</span><span class="css">
  <span class="hljs-selector-class">.select-wrapper</span> {
    <span class="hljs-attribute">width</span>: <span class="hljs-number">200px</span>;
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>禁用状态</h3>
<demo-block>
                <div class="source" slot="source"><ayu-select v-model="inputValue" placeholder="请选择" disabled>
  <ayu-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
    {{ item.label }}
  </ayu-option>
</ayu-select>


</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"inputValue"</span> <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"请选择"</span> <span class="hljs-attr">disabled</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ayu-option</span> 
    <span class="hljs-attr">v-for</span>=<span class="hljs-string">"item in options"</span> 
    <span class="hljs-attr">:key</span>=<span class="hljs-string">"item.value"</span> 
    <span class="hljs-attr">:label</span>=<span class="hljs-string">"item.label"</span> 
    <span class="hljs-attr">:value</span>=<span class="hljs-string">"item.value"</span>&gt;</span>
    {{ item.label }}
  <span class="hljs-tag">&lt;/<span class="hljs-name">ayu-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data() {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">inputValue</span>: <span class="hljs-string">''</span>,
        <span class="hljs-attr">options</span>: [
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'苹果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'apple'</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'香蕉'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Banana'</span>
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'火龙果'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Pitaya'</span>,
          },
          {
            <span class="hljs-attr">label</span>: <span class="hljs-string">'草莓'</span>,
            <span class="hljs-attr">value</span>: <span class="hljs-string">'Strawberry'</span>
          }
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">scoped</span>&gt;</span><span class="css">
  <span class="hljs-selector-class">.select-wrapper</span> {
    <span class="hljs-attribute">width</span>: <span class="hljs-number">200px</span>;
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">placeholder</td>
<td style="text-align:left">占位符</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">请选择</td>
</tr>
<tr>
<td style="text-align:left">optionKey</td>
<td style="text-align:left">作为 value 唯一标识的键名，绑定值为对象类型时必填</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">value</td>
</tr>
<tr>
<td style="text-align:left">multiple</td>
<td style="text-align:left">是否多选</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left">true/false</td>
<td style="text-align:left">false</td>
</tr>
<tr>
<td style="text-align:left">disabled</td>
<td style="text-align:left">是否禁用</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left">true/false</td>
<td style="text-align:left">false</td>
</tr>
<tr>
<td style="text-align:left">collapseTags</td>
<td style="text-align:left">是否缩略已选项</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left">true/false</td>
<td style="text-align:left">false</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
<th style="text-align:left">-</th>
<th style="text-align:left">-</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">change</td>
<td style="text-align:left">在 Select 值改变时触发</td>
<td style="text-align:left">Select Options</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">focus</td>
<td style="text-align:left">在 Select 获得焦点时触发</td>
<td style="text-align:left">event</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">blur</td>
<td style="text-align:left">在 Select 失去焦点时触发</td>
<td style="text-align:left">event</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
</tbody>
</table>
</section></template>
<style scoped>
  .select-wrapper {
    width: 200px;
  }
</style><style scoped>
  .select-wrapper {
    width: 200px;
  }
</style><style scoped>
  .select-wrapper {
    width: 200px;
  }
</style><style scoped>
  .select-wrapper {
    width: 200px;
  }
</style><style scoped>
  .select-wrapper {
    width: 200px;
  }
</style>
<script>
  export default {
    data() {
      return {
        inputValue: '',
        options: [
          {
            label: '苹果',
            value: 'apple'
          },
          {
            label: '香蕉',
            value: 'Banana'
          },
          {
            label: '火龙果',
            value: 'Pitaya',
          },
          {
            label: '草莓',
            value: 'Strawberry'
          }
        ],
        inputValue2: '',
        options2: [
          {
            label: '苹果',
            value: 'apple',
            disabled: true
          },
          {
            label: '香蕉',
            value: 'Banana'
          },
          {
            label: '火龙果',
            value: 'Pitaya',
            disabled: true
          },
          {
            label: '草莓',
            value: 'Strawberry'
          }
        ],
        inputValue3: ['apple', 'Banana'],
        options3: [
          {
            label: '苹果',
            value: 'apple',
          },
          {
            label: '香蕉',
            value: 'Banana'
          },
          {
            label: '火龙果',
            value: 'Pitaya',
          },
          {
            label: '草莓',
            value: 'Strawberry'
          }
        ],
        inputValue4: ['apple', 'Banana'],
        options4: [
          {
            label: '苹果',
            value: 'apple',
          },
          {
            label: '香蕉',
            value: 'Banana'
          },
          {
            label: '火龙果',
            value: 'Pitaya'
          },
          {
            label: '草莓',
            value: 'Strawberry'
          }
        ]
      }
    }
  }
</script>